import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { Textarea } from 'oxyrion-ui/lib';

class SelfStateTextarea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  componentDidMount() {
    this.setState({
      value: this.props.value || '',
    });
  }

  handleChange(e) {
    if (e.target.value.length <= 50) {
      this.setState({
        value: e.target.value,
      });
    }
  }
  render() {
    const { value } = this.state;
    const { onValueChange } = this.props;
    return (
      <Textarea
        {...this.props}
        style={{
          padding: rem(2),
          marginTop: rem(2),
          height: rem(30),
          width: 360,
        }}
        onChange={e => this.handleChange(e)}
        onBlur={() => onValueChange(value)}
        value={value}
      />
    );
  }
}

SelfStateTextarea.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func,
};

SelfStateTextarea.defaultProps = {
  value: '',
  onValueChange: () => {},
};

export default SelfStateTextarea;



// WEBPACK FOOTER //
// ./src/Components/SelfStateTextarea/index.jsx